import { render, staticRenderFns } from "./SynonymsSearchBar.vue?vue&type=template&id=4c759a6f"
import script from "./SynonymsSearchBar.vue?vue&type=script&lang=js"
export * from "./SynonymsSearchBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports